import getScheduleCheckinUniqueNumbers from './getScheduleCheckinUniqueNumbers';

export default {
  getScheduleCheckinUniqueNumbers,
}
